var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// Get followers for a user
export function fetchFollowers(targetUsername, status) {
    return __awaiter(this, void 0, Promise, function () {
        var query, response, error, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    query = "/api/db/followers?type=followers&targetUsername=".concat(targetUsername);
                    return [4 /*yield*/, fetch(status ? "".concat(query, "&status=").concat(status) : query)];
                case 1:
                    response = _a.sent();
                    if (!!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    error = _a.sent();
                    return [2 /*return*/, { error: error.error || 'Network response was not ok' }];
                case 3: return [4 /*yield*/, response.json()];
                case 4:
                    data = _a.sent();
                    return [2 /*return*/, { data: data }];
                case 5:
                    error_1 = _a.sent();
                    console.error('Error fetching followers: zzzzz', error_1);
                    return [2 /*return*/, { error: error_1.message }];
                case 6: return [2 /*return*/];
            }
        });
    });
}
// Get following list for a user
export function fetchFollowing(targetUsername, status, getFeed) {
    return __awaiter(this, void 0, Promise, function () {
        var query, response, error, data, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    query = "/api/db/followers?type=following&targetUsername=".concat(targetUsername, "&getFeed=").concat(getFeed);
                    return [4 /*yield*/, fetch(status ? "".concat(query, "&status=").concat(status) : query)];
                case 1:
                    response = _a.sent();
                    if (!!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    error = _a.sent();
                    return [2 /*return*/, { error: error.error || 'Network response was not ok' }];
                case 3: return [4 /*yield*/, response.json()];
                case 4:
                    data = _a.sent();
                    return [2 /*return*/, { data: data }];
                case 5:
                    error_2 = _a.sent();
                    console.error('Error fetching following list:', error_2);
                    return [2 /*return*/, { error: error_2.message }];
                case 6: return [2 /*return*/];
            }
        });
    });
}
// Get pending follow requests
export function fetchPendingFollowRequests(username) {
    return __awaiter(this, void 0, Promise, function () {
        var response, error, data, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    return [4 /*yield*/, fetch("/api/db/followers?type=pending&targetUsername=".concat(username))];
                case 1:
                    response = _a.sent();
                    if (!!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    error = _a.sent();
                    return [2 /*return*/, { error: error.error || 'Network response was not ok' }];
                case 3: return [4 /*yield*/, response.json()];
                case 4:
                    data = _a.sent();
                    return [2 /*return*/, { data: data }];
                case 5:
                    error_3 = _a.sent();
                    console.error('Error fetching pending requests:', error_3);
                    return [2 /*return*/, { error: error_3.message }];
                case 6: return [2 /*return*/];
            }
        });
    });
}
// Follow a user
export function followUser(username, userToFollow) {
    return __awaiter(this, void 0, Promise, function () {
        var response, error, data, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    console.log('following', username, userToFollow);
                    return [4 /*yield*/, fetch('/api/db/followers', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                username: username,
                                userToFollow: userToFollow,
                            }),
                        })];
                case 1:
                    response = _a.sent();
                    if (!!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    error = _a.sent();
                    return [2 /*return*/, { error: error.error || 'Network response was not ok' }];
                case 3: return [4 /*yield*/, response.json()];
                case 4:
                    data = _a.sent();
                    return [2 /*return*/, { data: data }];
                case 5:
                    error_4 = _a.sent();
                    console.error('Error following user:', error_4);
                    return [2 /*return*/, { error: error_4.message }];
                case 6: return [2 /*return*/];
            }
        });
    });
}
// Unfollow a user
export function unfollowUser(username, userToUnfollow) {
    return __awaiter(this, void 0, Promise, function () {
        var response, error, data, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    return [4 /*yield*/, fetch('/api/db/followers', {
                            method: 'DELETE',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                username: username,
                                userToUnfollow: userToUnfollow,
                            }),
                        })];
                case 1:
                    response = _a.sent();
                    if (!!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    error = _a.sent();
                    return [2 /*return*/, { error: error.error || 'Network response was not ok' }];
                case 3: return [4 /*yield*/, response.json()];
                case 4:
                    data = _a.sent();
                    return [2 /*return*/, { data: data }];
                case 5:
                    error_5 = _a.sent();
                    console.error('Error unfollowing user:', error_5);
                    return [2 /*return*/, { error: error_5.message }];
                case 6: return [2 /*return*/];
            }
        });
    });
}
// Update follow status (approve/block/etc)
export function updateFollowStatus(followerUsername, newStatus) {
    return __awaiter(this, void 0, Promise, function () {
        var response, error, data, error_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    return [4 /*yield*/, fetch('/api/db/followers', {
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                followerUsername: followerUsername,
                                newStatus: newStatus,
                            }),
                        })];
                case 1:
                    response = _a.sent();
                    if (!!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    error = _a.sent();
                    return [2 /*return*/, { error: error.error || 'Network response was not ok' }];
                case 3: return [4 /*yield*/, response.json()];
                case 4:
                    data = _a.sent();
                    return [2 /*return*/, { data: data }];
                case 5:
                    error_6 = _a.sent();
                    console.error('Error updating follow status:', error_6);
                    return [2 /*return*/, { error: error_6.message }];
                case 6: return [2 /*return*/];
            }
        });
    });
}
// Helper to check if a user is following another
export function checkFollowStatus(username, targetUsername) {
    return __awaiter(this, void 0, Promise, function () {
        var followingResult, followingUser, error_7;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetchFollowing(username)];
                case 1:
                    followingResult = _b.sent();
                    if (followingResult.error) {
                        return [2 /*return*/, { error: followingResult.error }];
                    }
                    followingUser = (_a = followingResult.data) === null || _a === void 0 ? void 0 : _a.find(function (f) { return f.username === targetUsername; });
                    return [2 /*return*/, {
                            data: {
                                isFollowing: !!followingUser,
                                status: (followingUser === null || followingUser === void 0 ? void 0 : followingUser.status) || null,
                            },
                        }];
                case 2:
                    error_7 = _b.sent();
                    console.error('Error checking follow status:', error_7);
                    return [2 /*return*/, { error: error_7.message }];
                case 3: return [2 /*return*/];
            }
        });
    });
}
